import React from 'react'
import { isEmpty } from 'lodash'

import GuestUserFields from './Client/GuestUserFields'
import ClientContactSelectionArea from './SupportDesk/ClientContactSelectionArea'

const TicketFormClientContactFields = ({
  currentUser,
  primaryContactName,
  primaryContactEmail,
  creatingContact,
  creatingContactForClient,
  clientId,
  clientContactId,
  clientName,
  setFieldErrorClasses,
  setFieldValue,
  clients,
  clientContactsLoading,
  clientNoticesContent,
  regionMetadata,
  chosenLocation,
  locations,
  clientsPropertiesWithHandlers,
  addClientContactListToClient,
  contactNumber,
  disabledContactNotifications,
  securityIssue
}) => {
  if (currentUser.isGuestUser) {
    return (
      <GuestUserFields {...{
        primaryContactName,
        setFieldValue,
        primaryContactEmail,
        clientName,
        regionMetadata,
        chosenLocation,
        locations
      }}
      />
    )
  }

  return (
    <ClientContactSelectionArea {...{
      clients,
      clientId,
      clientContactId,
      clientContactsLoading,
      clientNoticesContent,
      currentUser,
      setFieldValue,
      setFieldErrorClasses,
      clientsPropertiesWithHandlers,
      creatingContact,
      creatingContactForClient,
      addClientContactListToClient,
      contactNumber,
      disabledContactNotifications,
      securityIssue
    }}
    />
  )
}

export default TicketFormClientContactFields
